export default "__VITE_ASSET__6cca608f__"